import {useState} from 'react'

let currentRandomId = 0

export const useIncrementingId = () => {
  const [id] = useState(() => {
    currentRandomId += 1
    return `id_${currentRandomId}`
  })
  return id
}
